export default __webpack_public_path__ + "static/media/029-launcher.7cb9db62.png";